import { AppShell } from './components/layout/AppShell';

export function App(): JSX.Element {
  return <AppShell />;
}
